module.exports = __webpack_public_path__ + "img/Photo.c1a5e4e6.svg";